import { getSearchBarOptions } from "./search-bar.js"
import { positionPickerPanel, updateUrlSearchParams } from "./pickers-init.js"
import { submit as dynamicSearchSubmit } from "./dynamic-search.js"
import { lockout } from "./utilities.js";

let prevFocus;
let tmpAirports = '';

const activeClass = 'is-active';
const disabledAfterUncheckedAttribute = 'data-airport-picker-disable-after-unchecked';
const $pickerBlock = $('#form-searchblock');
const $airportPicker = $pickerBlock.find('.js-airport-picker');
const $airportPickerTrigger = $pickerBlock.find('.js-airport-picker-trigger');

const isSearchResultsPage = $pickerBlock.hasClass('js-dynamic-search');
const haveSearchValuesChanged = () => {
	const hiddenAirport = $pickerBlock.find('input[name="airport"]');

	if (hiddenAirport.val() !== tmpAirports) {
		hiddenAirport.val(tmpAirports);
		return true
	}

	return false;
}
const panelIsOpen = () => $airportPicker.hasClass(activeClass)
const closeAllPanels = () => {
	$pickerBlock.find('.c-pickers-panel').removeClass(activeClass);
	$pickerBlock.find('.js-date-picker-wrapper, .js-folks-selector-trigger, .js-airport-picker-trigger, .js-destination-picker-trigger').removeClass(activeClass);
}

function init() {
	attachEvents();
	checkIfCheckboxGroupShouldBePopulated();
	setChosenAirportsToTemp() // A page can be reloaded and the browser will hang onto to input values
	haveSearchValuesChanged() // So process the checkboxes on load
	setSelectedText();
}

const removeCloseListener = (event) => {
	if (!event.target.closest('.js-airport-picker-facade, .js-airport-picker-trigger, .c-airport-picker')) {
		closeAirportPicker();
	}
}

function attachEvents() {
	$airportPickerTrigger.on('click keypress', function(e) {
		if (e.type === 'click' || ((e.type === 'keypress') && e.which === 13)) {
			if (panelIsOpen()) {
				closeAllPanels()
				closeAirportPicker();
				window.site.body.off('click.airport', (e) => removeCloseListener(e))
			}
			else {
				if ($(this).find('.js-airport-picker-facade').is(':disabled')) { // Some destinations will disable Airport picker
					return false;
				}

				closeAllPanels()
				openAirportPicker();
				window.requestAnimationFrame(() => {
					window.site.body.on('click.airport', (e) => removeCloseListener(e))
				})
			}
		}

		e.preventDefault();
	});

	$pickerBlock.on('click', '.js-airport-picker-apply, .js-airport-picker-close', function() {
		closeAirportPicker();
	});

	$pickerBlock.on('change', '.js-airport-picker-checkbox', function() {
		setOtherCheckboxStateInGroup($(this));
		setSelectedText();
		setChosenAirportsToTemp();
	});

	window.site.doc.on("searchOptionsReceived", function(data) {
		if (data.options.EnableDepartureAirports) {
			enableAirportPicker();
		}
		else {
			disableAirportPicker();
		}

		setActiveAirports(data);
	});
}

function openAirportPicker() {
	prevFocus = document.activeElement;
	lockout.on('tablet')
	window.site.win.on('resize', () => {
		positionPickerPanel($pickerBlock, $airportPickerTrigger)
	});
	positionPickerPanel($pickerBlock, $airportPickerTrigger)
	$airportPicker.addClass(activeClass)
	$pickerBlock.find('.js-airport-picker-trigger, .js-airport-picker-facade-container').addClass(activeClass);
	$airportPicker.find('select, button, [href], input, [tabindex]:not([tabindex="-1"])').first().focus();

	window.requestAnimationFrame(() => {
		window.site.body.on('click.airport', (e) => removeCloseListener(e))
	})
}

function closeAirportPicker() {
	if (haveSearchValuesChanged()) {
		setSelectedText();

		getSearchBarOptions();
		if (isSearchResultsPage) {
			updateUrlSearchParams()
			dynamicSearchSubmit(false);
		}
	}

	$pickerBlock.find('.js-airport-picker-trigger, .js-airport-picker-facade-container, .js-airport-picker').removeClass(activeClass);
	window.site.win.off('resize', () => {
		positionPickerPanel($pickerBlock, $airportPickerTrigger)
	});

	window.site.body.off('click.airport')
	lockout.off()
	prevFocus?.focus();
}

const setChosenAirportsToTemp = () => {
	const checkedCheckboxes = $airportPicker.find('.js-airport-picker-checkbox:checked').not('.js-airport-picker-checkbox-group');

	const airportIds = [];
	checkedCheckboxes.each(function(index, element) {
		airportIds.push(element.getAttribute('data-airport-picker-iata'));
	});

	tmpAirports = airportIds.join('|');
}

function enableAirportPicker() {
	$pickerBlock.find('.js-airport-picker-facade').prop('disabled', false);
}

function disableAirportPicker() {
	$pickerBlock.find('.js-airport-picker-facade').prop('disabled', true);

	$pickerBlock.find('.js-airport-picker-checkbox').each(function() {
		const $this = $(this);
		$this.prop('checked', false);
		enableCheckbox($this);
	});

	tmpAirports = '';
	$pickerBlock.find('input[name="airport"]').val('');
	setSelectedText();
}

function setActiveAirports(data) {
	$pickerBlock.find('.js-airport-picker-checkbox').not('.js-airport-picker-checkbox-group').each(function() {
		const currentCheckbox = $(this);
		const inputValue = currentCheckbox.attr('data-airport-picker-iata');
		currentCheckbox.removeAttr(disabledAfterUncheckedAttribute);

		if (data.options.DepartureAirports.indexOf(inputValue) !== -1) {
			enableCheckbox(currentCheckbox);
		}
		else {
			if (currentCheckbox.is(':checked')) {
				currentCheckbox.attr(disabledAfterUncheckedAttribute, 'true');
			}
			else {
				disableCheckbox(currentCheckbox);
			}
		}

		setOtherCheckboxStateInGroup(currentCheckbox);
	});
}

function disableCheckbox(checkbox) {
	checkbox.prop('disabled', true);
	checkbox.closest('.c-airport-picker__list-item').addClass('c-airport-picker__list-item--disabled');
}

function enableCheckbox(checkbox) {
	checkbox.prop('disabled', false);
	checkbox.closest('.c-airport-picker__list-item').removeClass('c-airport-picker__list-item--disabled');
}

function setSelectedText() {
	const checkedCheckboxes = $pickerBlock.find('.js-airport-picker-checkbox:checked').not('.js-airport-picker-checkbox-group');

	if (!checkedCheckboxes.length) {
		const noneSelectedText = $pickerBlock.find('.js-airport-picker-facade').attr('data-airport-picker-none-selected-text');
		$pickerBlock.find('.js-airport-picker-facade').val(noneSelectedText);
		return;
	}

	let airportText = checkedCheckboxes.first().attr('data-airport-picker-name');
	if (checkedCheckboxes.length > 1) {
		airportText += ` + ${(checkedCheckboxes.length - 1).toString()}`;
	}

	$pickerBlock.find('.js-airport-picker-facade').val(airportText);
}

function setOtherCheckboxStateInGroup(checkboxChanged) {
	const isMasterCheckbox = checkboxChanged.hasClass('js-airport-picker-checkbox-group');
	const checkboxGroupContainer = checkboxChanged.closest('.js-airport-picker-group');

	if (isMasterCheckbox) {
		const isMasterCheckboxChecked = checkboxChanged.is(':checked');
		checkboxGroupContainer.find('.js-airport-picker-checkbox').not(':disabled').prop('checked', isMasterCheckboxChecked); //Makes all child checkboxs match the state of the master checkbox
	}
	else {
		if (checkboxChanged.is(':checked')) {
			// if all child checkboxes are now checked, then the master checkbox should also be checked
			shouldCheckboxGroupCheckboxBeChecked(checkboxGroupContainer);
		}
		else {
			checkboxGroupContainer.find('.js-airport-picker-checkbox-group').prop('checked', false);

			if (checkboxChanged.attr(disabledAfterUncheckedAttribute)) {
				disableCheckbox(checkboxChanged);
				checkboxChanged.removeAttr(disabledAfterUncheckedAttribute);
			}
		}

		shouldCheckboxGroupCheckboxBeDisabled(checkboxGroupContainer);
	}
}

function shouldCheckboxGroupCheckboxBeChecked(checkboxGroupContainer) {
	let someCheckboxesNotChecked = false;

	checkboxGroupContainer.find('.js-airport-picker-checkbox').not('.js-airport-picker-checkbox-group').each(function(index, element) {
		if (!$(element).is(':checked')) {
			someCheckboxesNotChecked = true;
			return false;
		}
	});

	checkboxGroupContainer.find('.js-airport-picker-checkbox-group').prop('checked', !someCheckboxesNotChecked);
}

function shouldCheckboxGroupCheckboxBeDisabled(checkboxGroupContainer) {
	let someCheckboxesNotDisabled = false;

	checkboxGroupContainer.find('.js-airport-picker-checkbox').not('.js-airport-picker-checkbox-group').each(function(index, element) {
		if (!$(element).is(':disabled')) {
			someCheckboxesNotDisabled = true;
			return false;
		}
	});

	if (someCheckboxesNotDisabled) {
		enableCheckbox(checkboxGroupContainer.find('.js-airport-picker-checkbox-group'));
	}
	else {
		disableCheckbox(checkboxGroupContainer.find('.js-airport-picker-checkbox-group'));
	}
}

function checkIfCheckboxGroupShouldBePopulated() {
	$airportPicker.find('.js-airport-picker-group').each(function() {
		shouldCheckboxGroupCheckboxBeChecked($(this));
	});
}

function reInitAfterSearch() {
	// re-assign airport picker text
	checkIfCheckboxGroupShouldBePopulated();
	setSelectedText();
}

export default init;
export { reInitAfterSearch, disableAirportPicker, enableAirportPicker }
